/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */

import React from 'react'
import { Field, FieldArray } from 'formik'
import { Fields, show, subscribe, unsubscribe, isEquals, Dash,
    CORP_SECTORS,
    MUNI_STATES_AND_TERRITORIES, MUNI_PURPOSES,
    CD_STATES_AND_TERRITORIES,
    AGENCY_TYPES,
    TREASURY_TYPES,
} from '../../twd'
import SubmitButton from './submit-button'
import { toSearchParams } from './to-search-params'
import PredefinedSearches from './predefined-searches'
import { initialValues } from './use-quick-screener'
const { Label, Labels } = Fields

let getResetValues = (curr) => {
    let invType = curr.invType
    let a = Object.assign({}, curr); delete a.invType
    let b = Object.assign({}, initialValues); delete b.invType

    if (!isEquals(a,b)) {
        return Object.assign({}, initialValues, {
            invType,
            holdSpRatingMin:'BBB-',
            holdSpRatingMax:'AAA',
            holdMoodyRatingMin:'Baa3',
            holdMoodyRatingMax:'Aaa',
        })
    }

    return Object.assign(b, {
        invType,
        rating: "all-ratings",
        holdMoodyRatingMin: "ALL",
        holdMoodyRatingMax: "ALL",
        holdSpRatingMin: "ALL",
        holdSpRatingMax: "ALL",
        muniGeneralObligation: false,
        muniRevenue: false,
        muniStates: [],
        muniTaxExempt: false,
        muniTaxable: false,
        cdBlueSky: [],
        cdNewIssue: false,
        cdSecondary: false,
        holdCallableInd: false,
    })
}

export default ({
    handleSubmit,
    values,
    errors,
    resetForm,
    validateForm,
}) => {

    React.useEffect(() => { validateForm() }, [])

    React.useEffect(() => {
        let subId = subscribe('overview_quick_screener_clear_all.overview_quick_screener_form', () => {
            resetForm(getResetValues(values))
            setTimeout(() => { validateForm() })
        })
        return () => {
            unsubscribe(subId)
        }
    }, [values])

    let invType = values.invType
    let isCorp = invType==='C'
    let isMuni = invType==='M'
    let isCD = invType==='S'
    let isTreasury = invType==='T'
    let isAgency = invType==='A'
    let hasRating = !(isCD || isTreasury)

    return (
    <form onSubmit={handleSubmit}>

    <div className="row vertical-offset-xs">
    <div className="col-xs-12 col-md-12">
        <div className="row"><div className="col-xs-12">
            <Label
                htmlFor="overview-quick-screener-securities"
                label="Securities"
                info={Labels.Securities} />
        </div></div>
        <Field
            id="overview-quick-screener-securities"
            dataName="overview-quick-screener-securities"
            name="invType"
            component={Fields.Select}
            options={[
                {label:'Corporates', value:'C'},
                {label:'Municipals', value:'M'},
                {label:'CDs', value:'S'},
                {label:'Agencies', value:'A'},
                {label:'U.S. Treasuries', value:'T'}
            ]}
        />
    </div>
    </div>

    {isCorp && <div className="row">
        <div className="col-xs-12 col-md-12">
            <div className="row"><div className="col-xs-12">
                <Label
                    htmlFor="overview-quick-screener-corp-sectors"
                    label="Sectors"
                    info={Labels.CorpSector} />
            </div></div>
            <FieldArray
                name="corpSectors"
                render={(args) => <Fields.SelectMulti {...args}
                    id="overview-quick-screener-corp-sectors"
                    dataName="overview-quick-screener-corp-sectors"
                    emptyText='All'
                    showSelectAll={true}
                    options={CORP_SECTORS}
                    style={{marginBottom:'10px'}}
                />}
            />
        </div>
    </div>}

    {isMuni && <React.Fragment>
        <div className="row">
        <div className="col-xs-12 col-md-12">
            <div className="row"><div className="col-xs-12">
                <Label
                    htmlFor="overview-quick-screener-muni-states"
                    label="State / Territory"
                    info={Labels.MuniStates} />
            </div></div>
            <FieldArray name="muniStates"
                render={(args) => <Fields.SelectMulti {...args}
                    id="overview-quick-screener-muni-states"
                    dataName="overview-quick-screener-muni-states"
                    showSelectAll={true}
                    options={MUNI_STATES_AND_TERRITORIES}
                    style={{marginBottom:'10px'}}
                />}
            />
        </div>
        </div>

        <div className="row">
        <div className="col-xs-12 col-md-12">
            <div className="row"><div className="col-xs-12">
                <Label
                    htmlFor="overview-quick-screener-muni-states"
                    label="Use of proceeds"
                    info={Labels.MuniPurposes} />
            </div></div>
            <FieldArray name="muniPurposes"
                render={(args) => <Fields.SelectMulti {...args}
                    id="overview-quick-screener-muni-use-of-proceeds"
                    dataName="overview-quick-screener-muni-use-of-proceeds"
                    showSelectAll={true}
                    options={MUNI_PURPOSES}
                    style={{marginBottom:'10px'}}
                />}
            />
        </div>
        </div>

        <div className="row">
        <div className="col-xs-12 col-md-12 col-lg-6">
            <div className="row"><div className="col-xs-12">
                <Label
                    htmlFor="overview-quick-screener-muni-general-obligation"
                    label="Category"
                    info={Labels.MuniCategories} />
            </div></div>
            <div className="row"><div className="col-md-12 col-xs-12">
                <div className="vertical-offset-xxs"></div>
                <Field
                    id="overview-quick-screener-muni-general-obligation"
                    data-name="overview-quick-screener-muni-general-obligation"
                    name="muniGeneralObligation"
                    component={Fields.Checkbox}
                    label="General Obligation"
                />
            </div></div>
            <div className="row"><div className="col-md-12 col-xs-12">
                <div className="vertical-offset-xxs"></div>
                <Field
                    data-name="overview-quick-screener-muni-revenue"
                    name="muniRevenue"
                    component={Fields.Checkbox}
                    label="Revenue"
                />
            </div></div>
        </div>
        <div className="col-xs-12 col-md-12 col-lg-6">
            <div className="row"><div className="col-xs-12">
                <Label
                    label="Tax Treatment"
                    info={Labels.MuniTaxTreatments} />
            </div></div>
            <div className="row"><div className="col-md-12 col-xs-12">
                <div className="vertical-offset-xxs"></div>
                <Field
                    data-name="overview-quick-screener-muni-tax-exempt"
                    name="muniTaxExempt"
                    component={Fields.Checkbox}
                    label="Tax-Exempt"
                />
            </div></div>
            <div className="row"><div className="col-md-12 col-xs-12">
                <div className="vertical-offset-xxs"></div>
                <Field
                    data-name="overview-quick-screener-muni-taxable"
                    name="muniTaxable"
                    component={Fields.Checkbox}
                    label="Taxable"
                />
            </div></div>
        </div>
        </div>
    </React.Fragment>}

    {isCD && <React.Fragment>
        <div className="row">
        <div className="col-xs-12 col-md-12">
            <div className="row"><div className="col-xs-12">
                <Label
                    htmlFor="overview-quick-screener-cd-bluesky"
                    label="Blue Sky Restriction"
                    info={CD_BLUESKY_INFO}/>
            </div></div>
            <FieldArray name="cdBlueSky"
                render={(args) => <Fields.SelectMulti {...args}
                    id="overview-quick-screener-cd-bluesky"
                    dataName="overview-quick-screener-cd-bluesky"
                    emptyText='All'
                    showSelectAll={true}
                    options={CD_STATES_AND_TERRITORIES}
                    style={{marginBottom:'10px'}}
                />}
            />
        </div>
        </div>

        <div className="row">
        <div className="col-xs-12 col-md-12">
            <div className="row"><div className="col-xs-12">
                <Label
                    label="Market type"
                    info={Labels.CorpMarketTypes} />
            </div></div>
            <div className="row">
                <div className="col-md-6">
                    <div className="vertical-offset-xxs"></div>
                    <Field
                        data-name="overview-quick-screener-cd-new-issue"
                        name="cdNewIssue"
                        component={Fields.Checkbox}
                        label="New Issue"
                    />
                </div>
                <div className="col-md-6">
                    <div className="vertical-offset-xxs"></div>
                    <Field
                        data-name="overview-quick-screener-cd-secondary"
                        name="cdSecondary"
                        component={Fields.Checkbox}
                        label="Secondary"
                    />
                </div>
            </div>
        </div>
        </div>
    </React.Fragment>}

    {isAgency && <React.Fragment>
        <div className="row">
        <div className="col-xs-12 col-md-12">
            <div className="row"><div className="col-xs-12">
                <Label label="Agency/GSE" info={Labels.AgencyTypes} />
            </div></div>
            <FieldArray name="agencyTypes"
                render={(args) => <Fields.SelectMulti {...args}
                    dataName="overview-quick-screener-agency-issuer"
                    emptyText='All'
                    showSelectAll={true}
                    options={AGENCY_TYPES}
                    listConfig={{ style: { minWidth:'325px' } }}
                    style={{marginBottom:'10px'}}
                />}
            />
        </div>
        </div>
    </React.Fragment>}

    {isTreasury && <React.Fragment>
        <div className="row">
        <div className="col-xs-12 col-md-12">
            <div className="row"><div className="col-xs-12">
                <Label label="Type" info={Labels.TreasuryTypes} />
            </div></div>
            <FieldArray name="treasuryTypes"
                render={(args) => <Fields.SelectMulti {...args}
                    dataName="overview-quick-screener-treasury-type"
                    emptyText='All'
                    showSelectAll={true}
                    options={TREASURY_TYPES}
                    style={{marginBottom:'10px'}}
                />}
            />
        </div>
        </div>
    </React.Fragment>}

    <div className="row">
    <div className="col-xs-12 col-md-6">
        <div className="row"><div className="col-xs-12">
            <Fields.Label label="Maturity Date" info={Fields.Labels.Maturity} />
        </div></div>
        <div className="row">
            <div className="col-xs-6">
            <Field
                data-name="overview-quick-screener-maturity-min"
                name="holdMaturityMin"
                component={Fields.Maturity}
                label="Min"
                error={errors.holdMaturity}
            />
            </div>
            <div className="col-xs-6">
            <Field
                data-name="overview-quick-screener-maturity-min"
                name="holdMaturityMax"
                component={Fields.Maturity}
                label="Max"
                error={errors.holdMaturity}
            />
            </div>
            {errors.holdMaturity && (
                <label className="field-status has-error">{errors.holdMaturity}</label>
            )}
            <Dash />
        </div>
    </div>
    <div className="col-xs-12 col-md-6">
        <div className="row"><div className="col-xs-12">
            <Fields.Label label="Quantity" info={Fields.Labels.Quantity} />
        </div></div>
        <div className="row">
            <div className="col-xs-6 col-md-6">
            <Field
                data-name="overview-quick-screener-quantity-min"
                name="quantityMin"
                component={Fields.Quantity}
                label="Min"
                error={errors.quantity}
            />
            </div>
            <div className="col-xs-6 col-md-6">
            <Field
                data-name="overview-quick-screener-quantity-max"
                name="quantityMax"
                component={Fields.Quantity}
                label="Max"
                error={errors.quantity}
            />
            </div>
            {errors.quantity && (
                <label className="field-status has-error">{errors.quantity}</label>
            )}
            <Dash />
        </div>
    </div>
    </div>


    <div className="row">
    <div className="col-xs-12 col-md-6">
        <div className="row"><div className="col-xs-12">
            <Fields.Label label="Yield" info={Fields.Labels.Yield} />
        </div></div>
        <div className="row">
            <div className="col-xs-6">
            <Field
                data-name="overview-quick-screener-yield-min"
                name="offerYtwMin"
                component={Fields.Yield}
                placeholder="%"
                error={errors.offerYtw}
                label="Min"
            />
            </div>
            <div className="col-xs-6">
            <Field
                data-name="overview-quick-screener-yield-max"
                name="offerYtwMax"
                component={Fields.Yield}
                placeholder="%"
                error={errors.offerYtw}
                label="Max"
            />
            </div>
            {errors.offerYtw && (
                <label className="field-status has-error">{errors.offerYtw}</label>
            )}
            <Dash />
        </div>
    </div>
    <div className="col-xs-12 col-md-6">
        <div className="row"><div className="col-xs-12">
            <Fields.Label label="Price" info={Fields.Labels.Price} />
        </div></div>
        <div className="row">
            <div className="col-xs-6 col-md-6">
            <Field
                data-name="overview-quick-screener-price-min"
                name="clientPriceMin"
                component={Fields.Price}
                placeholder="$"
                error={errors.clientPrice}
                label="Min"
            />
            </div>
            <div className="col-xs-6 col-md-6">
            <Field
                data-name="overview-quick-screener-price-max"
                name="clientPriceMax"
                component={Fields.Price}
                placeholder="$"
                error={errors.clientPrice}
                label="Max"
            />
            </div>
            {errors.clientPrice && (
                <label className="field-status has-error">{errors.clientPrice}</label>
            )}
            <Dash />
        </div>
    </div>
    </div>

    {hasRating && <React.Fragment>
        <div className="row">
        <div className="col-xs-12 col-md-12">
            <div className="row"><div className="col-xs-12">
                <Fields.Label
                    id="overview-quick-screener-rating-label"
                    label="Rating" info={Fields.Labels.Rating} />
            </div></div>

            <div className="row">
                <div className="col-xs-12 col-md-12">
                <Field
                    data-name="overview-quick-screener-rating-investment-grade"
                    aria-describedby="overview-quick-screener-rating-label"
                    name="rating"
                    component={Fields.Radio}
                    value="investment-grade"
                    label="Investment Grade"
                    className="radio-inline"
                    onClick={() => {
                        Object.assign(values, {
                            holdSpRatingMin:'BBB-',
                            holdSpRatingMax:'AAA',
                            holdMoodyRatingMin:'Baa3',
                            holdMoodyRatingMax:'Aaa'
                        })
                    }} />
                &nbsp;
                &nbsp;
                <Field
                    data-name="overview-quick-screener-rating-high-yield"
                    aria-describedby="overview-quick-screener-rating-label"
                    name="rating"
                    component={Fields.Radio}
                    value="high-yield"
                    label="High Yield"
                    className="radio-inline"
                    onClick={() => {
                        Object.assign(values, {
                            holdSpRatingMin:'C',
                            holdSpRatingMax:'BB+',
                            holdMoodyRatingMin:'C',
                            holdMoodyRatingMax:'Ba1'
                        })
                    }} />
                &nbsp;
                &nbsp;
                <Field
                    data-name="overview-quick-screener-rating-all-ratings"
                    name="rating" component={Fields.Radio}
                    value="all-ratings"
                    label="All ratings"
                    className="radio-inline"
                    onClick={() => {
                        Object.assign(values, {
                            holdSpRatingMin:'ALL',
                            holdSpRatingMax:'ALL',
                            holdMoodyRatingMin:'ALL',
                            holdMoodyRatingMax:'ALL'
                        })
                    }} />
                </div>
            </div>
        </div>
        </div>

        <div className="row">
        <div className="col-xs-12 col-md-12 col-lg-6">
            <div className="row"><div className="col-xs-12">
                <Fields.Label label="Moody's" />
            </div></div>
            <div className="row">
                <div className="col-xs-6">
                <Field
                    dataName="overview-quick-screener-moodys-credit-rating-min"
                    name="holdMoodyRatingMin"
                    component={Fields.Rating}
                    ratingType='moodys'
                    error={errors.holdMoodyRating}
                    label='Min'
                    ariaLabel="Minimum Moody's Rating"
                />
                </div>
                <div className="col-xs-6">
                <Field
                    dataName="overview-quick-screener-moodys-credit-rating-max"
                    name="holdMoodyRatingMax"
                    component={Fields.Rating}
                    ratingType='moodys'
                    error={errors.holdMoodyRating}
                    label='Max'
                    ariaLabel="Maximum Moody's Rating"
                />
                </div>
                {errors.holdMoodyRating && (
                    <label className="field-status has-error">{errors.holdMoodyRating}</label>
                )}
                <Dash margin={10} />
            </div>
        </div>
        <div className="col-xs-12 col-md-12 col-lg-6">
            <div className="row"><div className="col-xs-12">
                <Fields.Label label="S&amp;P" />
            </div></div>
            <div className="row">
                <div className="col-xs-6 col-md-6">
                <Field
                    dataName="overview-quick-screener-sp-credit-rating-min"
                    name="holdSpRatingMin"
                    component={Fields.Rating}
                    ratingType='sp'
                    error={errors.holdSpRating}
                    label='Min'
                    ariaLabel="Minimum S&ampP Rating"
                />
                </div>
                <div className="col-xs-6 col-md-6">
                <Field
                    dataName="overview-quick-screener-sp-credit-rating-max"
                    name="holdSpRatingMax"
                    component={Fields.Rating}
                    ratingType='sp'
                    error={errors.holdSpRating}
                    label='Max'
                    ariaLabel="Maximum S&ampP Rating"
                />
                </div>
                {errors.holdSpRating && (
                    <label className="field-status has-error">{errors.holdSpRating}</label>
                )}
                <Dash margin={10} />
            </div>
        </div>
        </div>

        <div className="row vertical-offset-xs"></div>
        <div className="row">
        <div className="col-xs-12 col-md-12">
            <Field
                data-name="overview-quick-screener-credit-ratings-and-or"
                name="holdRatingAndOr"
                component={Fields.Checkbox}
                label="Results can match Moody's or S&amp;P ratings selection"
            />
        </div>
        </div>
    </React.Fragment>}

    {!isTreasury && <React.Fragment>
        {!hasRating && <div className="row vertical-offset-xs"></div>}

        <div className="row">
        <div className="col-xs-12 col-md-12" hidden={ isTreasury }>
            <Field
                data-name="overview-quick-screener-exclude-callable"
                name="holdCallableInd"
                component={Fields.Checkbox}
                label="Exclude Callable"
            />
        </div>
        </div>
    </React.Fragment>}


    <div className="row vertical-offset-base"></div>

    <div className="row">
    <div className="col-xs-12 col-md-12">
        <SubmitButton errors={errors} values={values} />
    </div>
    </div>

    <div className="row">
        <div className="col-xs-12 text-center">
            <button
                data-name="overview-quick-screener-advanced-screener"
                className="btn btn-link"
                onClick={() => {
                    let p = toSearchParams(values)
                    if (!p.holdState) {
                        p.holdState = []
                    }
                    p.isEdit = true

                    show('advanced-screener', Object.assign({
                        searchParams: p,
                        _ts: Date.now(),
                        from:'overview'
                    }))
                }}
            >Advanced Screener</button>
        </div>
    </div>

    <PredefinedSearches invType={values.invType} />
    </form>
    )
}

const CD_BLUESKY_INFO = `
<p>This filter ensures your search results do not contain any brokered CD offers which have
Blue Sky restrictions in your state of residence.</p>

<p>What are Blue Sky restrictions? Individual states have a set of securities laws,
commonly referred to as Blue Sky Laws, which govern the sale of securities in their state.
These laws, which vary by state, are established to protect investors from securities fraud.
CD offerings from issuing banks that do not comply with a state's Blue Sky Laws
are restricted from sale to residents of that state.</p>
`